// Action pour ouvrir le lien dans différents calendriers
export const openCalendar = (target = "outlook", { date, duree, titre, coach, lieu, type }, handleSuccess = null, handleError = null) => {
    let url = null;

    // Sélection de la fonction de génération appropriée selon la cible
    switch (target) {
        case "outlook":
            url = generateOutlookCalendarUrlForSeance({ date, duree, titre, coach, lieu, type });
            break;
        case "google":
            url = generateGoogleCalendarUrlForSeance({ date, duree, titre, coach, lieu, type });
            break;
        case "apple":
            url = generateAppleCalendarUrlForSeance({ date, duree, titre, coach, lieu, type });
            break;
        case "office365":
            url = generateOffice365CalendarUrlForSeance({ date, duree, titre, coach, lieu, type });
            break;
        default:
            handleError && handleError(`Type de calendrier non supporté: ${target}`);
            return;
    }

    if (!url) {
        handleError && handleError('Impossible de générer le lien agenda');
        return;
    }

    window.open(url, '_blank', 'noopener,noreferrer');
    handleSuccess && handleSuccess(`Lien ouvert dans un nouvel onglet`);
};


export const openCalendarForComment = (target = "outlook", {date, title, text}, handleSuccess = null, handleError = null) => {
    let url = null;

    switch (target) {
        case "outlook":
            url = generateOutlookCalendarUrlForComment({date, title, text});
            break;
        case "google":
            url = generateOutlookCalendarUrlForComment({date, title, text});
            break;
        case "apple":
            url = generateOutlookCalendarUrlForComment({date, title, text});
            break;
        case "office365":
            url = generateOutlookCalendarUrlForComment({date, title, text});
            break;
        default:
            handleError && handleError(`Type de calendrier non supporté: ${target}`);
            return;
    }

    if (!url) {
        handleError && handleError('Impossible de générer le lien agenda');
        return;
    }

    window.open(url, '_blank', 'noopener,noreferrer');
    handleSuccess && handleSuccess(`Lien ouvert dans un nouvel onglet`);
};

export const generateOutlookCalendarUrlForComment = ({date, title, text}) => {
    if (!date) return null;
    if (!(date instanceof Date)) {
        date = new Date(date);
    }

    const startDate = date;
    console.log({
        startDate,

    });
    const endDate = new Date(startDate.getTime() + (60 * 1000)); // on ajoute 1 min

    // Construction des éléments de l'événement avec formatage spécifique Outlook
    const eventTitle = `${title}`;
    const eventDescription = `${text}`;

    return generateOutlookCalendarUrl({
        startDate: startDate,
        endDate: endDate,
        eventTitle: eventTitle,
        eventDescription: eventDescription,
    });
};

export const generateOutlookCalendarUrlForSeance = (seanceData) => {
    if (!seanceData || !seanceData.date) return null;

    const startDate = new Date(seanceData.date);
    const endDate = new Date(startDate.getTime() + (seanceData.duree * 60 * 1000));

    // Construction des éléments de l'événement avec formatage spécifique Outlook
    const eventTitle = `${seanceData.titre}`;
    const eventDescription = `${seanceData.titre} avec ${seanceData.coach.prenom}.\n\nDurée: ${seanceData.duree} minutes.\nLieu: ${seanceData.lieu.nom}, ${seanceData.lieu.adresse} à ${seanceData.lieu.ville}, ${seanceData.lieu.code_postal}.\n\nN'oubliez pas d'apporter une tenue adaptée et de quoi vous hydrater pendant la séance.`;
    const eventLocation = seanceData.lieu.adresse ? `${seanceData.lieu.nom}, ${seanceData.lieu.adresse}, ${seanceData.lieu.ville} - ${seanceData.lieu.code_postal}` : '';

    return generateOutlookCalendarUrl({
        startDate: startDate,
        endDate: endDate,
        eventTitle: eventTitle,
        eventDescription: eventDescription,
        eventLocation: eventLocation
    });
};

export const generateOutlookCalendarUrl = ({ startDate = "", endDate = "", eventTitle = "", eventDescription = "", eventLocation = ""}) => {
    if (!startDate) return null;

    const baseUrl = 'https://outlook.office.com/calendar/0/action/compose';

    // Conversion en objets Date si nécessaire
    if (!(startDate instanceof Date)) {
        startDate = new Date(startDate);
    }
    if (!(endDate instanceof Date)) {
        endDate = new Date(endDate);
    }

    // Formatage spécifique Outlook : ISO sans le 'Z' final
    const formatDateForOutlook = (date) => {
        return date.toISOString().slice(0, 19);
    };

    // Construction des paramètres avec tous les champs requis par Outlook
    const params = new URLSearchParams({
        allday: 'false',
        subject: eventTitle,
        body: eventDescription,
        location: eventLocation,
        startdt: formatDateForOutlook(startDate),
        enddt: formatDateForOutlook(endDate),
        path: '/calendar/action/compose',
        rru: 'addevent'
    });

    return `${baseUrl}?${params.toString()}`;
};

// Générateur spécifique Google Calendar
export const generateGoogleCalendarUrlForSeance = (seanceData) => {
    if (!seanceData || !seanceData.date) return null;

    const startDate = new Date(seanceData.date);
    const endDate = new Date(startDate.getTime() + (seanceData.duree * 60 * 1000));

    // Google Calendar préfère des descriptions plus courtes et structurées
    const eventTitle = `${seanceData.titre}`;
    const eventDescription = `Séance avec ${seanceData.coach.prenom} - Durée: ${seanceData.duree}min. N'oubliez pas d'apporter une tenue adaptée et de quoi vous hydrater pendant la séance.`;
    const eventLocation = seanceData.lieu.adresse ? `${seanceData.lieu.nom}, ${seanceData.lieu.adresse}, ${seanceData.lieu.ville}` : seanceData.lieu.nom;

    return generateGoogleCalendarUrl({
        startDate: startDate,
        endDate: endDate,
        eventTitle: eventTitle,
        eventDescription: eventDescription,
        eventLocation: eventLocation
    });
};

export const generateGoogleCalendarUrl = ({ startDate = "", endDate = "", eventTitle = "", eventDescription = "", eventLocation = ""}) => {
    if (!startDate) return null;

    const baseUrl = 'https://calendar.google.com/calendar/render';

    // Conversion en objets Date si nécessaire
    if (!(startDate instanceof Date)) {
        startDate = new Date(startDate);
    }
    if (!(endDate instanceof Date)) {
        endDate = new Date(endDate);
    }

    // Formatage spécifique Google : format UTC avec 'Z' final
    // Google utilise le format YYYYMMDDTHHMMSSZ pour les dates
    const formatDateForGoogle = (date) => {
        return date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
    };

    // Google Calendar utilise une plage de dates concaténée avec '/'
    const dateRange = `${formatDateForGoogle(startDate)}/${formatDateForGoogle(endDate)}`;

    // Construction des paramètres spécifiques à Google Calendar
    const params = new URLSearchParams({
        action: 'TEMPLATE',
        dates: dateRange,
        text: eventTitle,
        details: eventDescription,
        location: eventLocation
    });

    return `${baseUrl}?${params.toString()}`;
};

// Générateur spécifique Apple Calendar (utilise le protocole webcal)
export const generateAppleCalendarUrlForSeance = (seanceData) => {
    if (!seanceData || !seanceData.date) return null;

    const startDate = new Date(seanceData.date);
    const endDate = new Date(startDate.getTime() + (seanceData.duree * 60 * 1000));

    // Apple Calendar fonctionne différemment - il utilise des fichiers ICS
    // Pour une approche web, on peut créer un lien de téléchargement ICS
    const eventTitle = `${seanceData.titre}`;
    const eventDescription = `${seanceData.titre} avec ${seanceData.coach.prenom}. Durée: ${seanceData.duree} minutes. Lieu: ${seanceData.lieu.nom}. N'oubliez pas d'apporter une tenue adaptée et de quoi vous hydrater pendant la séance.`;
    const eventLocation = seanceData.lieu.adresse ? `${seanceData.lieu.nom}, ${seanceData.lieu.adresse}, ${seanceData.lieu.ville}` : seanceData.lieu.nom;

    return generateAppleCalendarUrl({
        startDate: startDate,
        endDate: endDate,
        eventTitle: eventTitle,
        eventDescription: eventDescription,
        eventLocation: eventLocation
    });
};

export const generateAppleCalendarUrl = ({ startDate = "", endDate = "", eventTitle = "", eventDescription = "", eventLocation = ""}) => {
    if (!startDate) return null;

    // Conversion en objets Date si nécessaire
    if (!(startDate instanceof Date)) {
        startDate = new Date(startDate);
    }
    if (!(endDate instanceof Date)) {
        endDate = new Date(endDate);
    }

    // Apple Calendar utilise le format ICS (iCalendar)
    // Formatage des dates pour ICS : YYYYMMDDTHHMMSSZ
    const formatDateForICS = (date) => {
        return date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
    };

    // Génération du contenu ICS complet
    const icsContent = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//Your App//Event//EN',
        'BEGIN:VEVENT',
        `DTSTART:${formatDateForICS(startDate)}`,
        `DTEND:${formatDateForICS(endDate)}`,
        `SUMMARY:${eventTitle.replace(/,/g, '\\,')}`,
        `DESCRIPTION:${eventDescription.replace(/,/g, '\\,').replace(/\n/g, '\\n')}`,
        `LOCATION:${eventLocation.replace(/,/g, '\\,')}`,
        `UID:${Date.now()}@yourdomain.com`,
        'END:VEVENT',
        'END:VCALENDAR'
    ].join('\r\n');

    // Création d'un blob et d'une URL de téléchargement
    const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
    return URL.createObjectURL(blob);
};

// Générateur spécifique Office 365 (différent d'Outlook web)
export const generateOffice365CalendarUrlForSeance = (seanceData) => {
    if (!seanceData || !seanceData.date) return null;

    const startDate = new Date(seanceData.date);
    const endDate = new Date(startDate.getTime() + (seanceData.duree * 60 * 1000));

    // Office 365 a un formatage similaire à Outlook mais avec des nuances
    const eventTitle = `${seanceData.titre}`;
    const eventDescription = `${seanceData.titre} avec ${seanceData.coach.prenom}.\n\nDurée: ${seanceData.duree} minutes.\nLieu: ${seanceData.lieu.nom}.\n\nN'oubliez pas d'apporter une tenue adaptée et de quoi vous hydrater pendant la séance.`;
    const eventLocation = seanceData.lieu.adresse ? `${seanceData.lieu.nom}, ${seanceData.lieu.adresse}, ${seanceData.lieu.ville}` : seanceData.lieu.nom;

    return generateOffice365CalendarUrl({
        startDate: startDate,
        endDate: endDate,
        eventTitle: eventTitle,
        eventDescription: eventDescription,
        eventLocation: eventLocation
    });
};

export const generateOffice365CalendarUrl = ({ startDate = "", endDate = "", eventTitle = "", eventDescription = "", eventLocation = ""}) => {
    if (!startDate) return null;

    // Office 365 utilise une URL légèrement différente d'Outlook web
    const baseUrl = 'https://outlook.office365.com/calendar/0/action/compose';

    // Conversion en objets Date si nécessaire
    if (!(startDate instanceof Date)) {
        startDate = new Date(startDate);
    }
    if (!(endDate instanceof Date)) {
        endDate = new Date(endDate);
    }

    // Formatage identique à Outlook : ISO sans le 'Z'
    const formatDateForOffice365 = (date) => {
        return date.toISOString().slice(0, 19);
    };

    // Paramètres similaires à Outlook avec quelques spécificités Office 365
    const params = new URLSearchParams({
        allday: 'false',
        subject: eventTitle,
        body: eventDescription,
        location: eventLocation,
        startdt: formatDateForOffice365(startDate),
        enddt: formatDateForOffice365(endDate),
        path: '/calendar/action/compose',
        rru: 'addevent'
    });

    return `${baseUrl}?${params.toString()}`;
};

// Fonction utilitaire pour détecter le navigateur/OS et suggérer le bon calendrier
export const getRecommendedCalendarType = () => {
    const userAgent = navigator.userAgent.toLowerCase();

    // Détection d'iOS (iPhone/iPad) -> Apple Calendar
    if (/iphone|ipad|ipod/.test(userAgent)) {
        return 'apple';
    }

    // Détection de macOS -> Apple Calendar
    if (/macintosh|mac os x/.test(userAgent)) {
        return 'apple';
    }

    // Détection d'Android -> Google Calendar
    if (/android/.test(userAgent)) {
        return 'google';
    }

    // Détection de Windows -> Outlook
    if (/windows/.test(userAgent)) {
        return 'outlook';
    }

    // Par défaut, Google Calendar (le plus universel)
    return 'google';
};

// Fonction pour télécharger un fichier ICS (spécialement pour Apple)
export const downloadICSFile = (icsUrl, filename = 'event.ics') => {
    const link = document.createElement('a');
    link.href = icsUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Nettoyage de l'URL blob après téléchargement
    URL.revokeObjectURL(icsUrl);
};